module.exports = __webpack_public_path__ + "static/media/6630.5fe96a81.jpg";